<template>
  <div>
    <h1>{{ t("DMCA") }}</h1>

    <h2>{{ t("Intellectual Property Policy and Procedures") }}</h2>

    <p>
      {{
        t(
          'Ersties Team processes claims of copyright infringement in accordance with the Digital Millennium Copyright Act of 1998("DMCA"), 17 U.S.C. § 512 et.seq.The DMCA addresses the rights and obligations of owners of copyrighted material who believe that their rights under U.S.copyright law have been infringed upon on the Internet, as well as the rights and obligations of Internet Service Providers on whose websites infringing material may reside.',
        )
      }}
    </p>

    <p>
      {{
        t(
          "If you believe that your work has been copied, adapted, reproduced, or exhibited on Ersties in a way that constitutes copyright infringement, or that otherwise violates your intellectual property rights, you may provide written notice of the claimed infringing activity to our designated agent.Your notice must include the following information:",
        )
      }}
    </p>
    <ul>
      <li>{{ t("Your physical or electronic signature;") }}</li>
      <li>
        {{
          t(
            "Identification of the copyrighted work claimed to have been infringed. If multiple copyrighted works from a single online site are covered in one claim, you must include a complete representative list of such works;",
          )
        }}
      </li>
      <li>
        {{
          t(
            "Identification of the material that it is claimed to be infringing, or to be the subject of infringing activity, and information reasonably sufficient to permit us to locate the material;",
          )
        }}
      </li>
      <li>{{ t("Your name, address, telephone number, and e - mail address;") }}</li>
      <li>
        {{
          t(
            "A statement that you have a good faith belief that the use of the material in the manner identified is not authorized by the copyright owner, its agent, or the law;",
          )
        }}
      </li>
      <li>
        {{
          t(
            "A statement, under penalty of perjury, that the information in the notification is accurate and that you are the owner of an exclusive right that is allegedly infringed, or are authorized to act on the owner's behalf.",
          )
        }}
      </li>
    </ul>

    <h2>{{ t("Designation of Agent to Receive Notification of Claimed Infringement") }}</h2>

    <p>
      {{
        t(
          "NOTE: THE FOLLOWING INFORMATION IS PROVIDED SOLELY FOR NOTIFYING OUR DESIGNATED AGENT THAT YOUR COPYRIGHTED MATERIAL MAY HAVE BEEN INFRINGED.DO NOT SEND ANY INQUIRIES UNRELATED TO COPYRIGHT INFRINGEMENT (E.G., REQUESTS FOR CUSTOMER SERVICE OR TECHNICAL SUPPORT) TO THE CONTACT LISTED.",
        )
      }}
    </p>
    <p>{{ t("Our designated agent to receive notification of claimed infringement is:") }}</p>
    <p>{{ t("Designated DMCA Agent") }}</p>

    <imprint :show-title="false" />

    <p>
      {{
        t(
          "Please note that under federal law, if you knowingly make a material misrepresentation that online material is infringing, you may be subject to significant civil penalties including, but not necessarily limited to: monetary damages, court costs, and attorneys fees incurred by us, by any copyright owner, or by any copyright owner's licensee that is injured as a result of your misrepresentation.",
        )
      }}
    </p>

    <h2>{{ t("Notice and Takedown") }}</h2>

    <p>{{ t("Upon receipt of written notification provided in the manner required by 17 U.S.C. § 512, we will:") }}</p>
    <ul>
      <li>{{ t("Remove or disable access to the material that is alleged to be infringing;") }}</li>
      <li>{{ t('Forward the written notification to the alleged infringer ("User"); and') }}</li>
      <li>{{ t("Take reasonable steps to promptly notify the User that we have removed or disabled access to the material.") }}</li>
    </ul>

    <h2>{{ t("Counter - Notification") }}</h2>

    <p>
      {{
        t(
          "If you are a User who has received notice from us that material has been removed from our website following our receipt of a notice of copyright infringement, and you are the owner of the material that was removed or are otherwise authorized to use such material, you may provide written counter - notification to our designated agent.Your counter - notification must include the following information:",
        )
      }}
    </p>
    <ul>
      <li>{{ t("Your physical or electronic signature;") }}</li>
      <li>
        {{
          t(
            "Identification of the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access to it was disabled;",
          )
        }}
      </li>
      <li>
        {{
          t(
            "A statement, under penalty of perjury, that you have a good faith belief that the material was removed or disabled as a result of mistake or misidentification;",
          )
        }}
      </li>
      <li>{{ t("Your name, address, telephone number, and e - mail address;") }}</li>
      <li>
        {{
          t(
            "A statement that you consent to the jurisdiction of the Federal District Court for the judicial district in which you are located, or if your address is outside of the United States, of any judicial district in which we do business, and that you will accept service of process from the complaining party or his agent.",
          )
        }}
      </li>
    </ul>

    <p>{{ t("Upon receipt of written counter - notification provided in the manner required by 17 U.S.C. § 512, we will:") }}</p>
    <ul>
      <li>{{ t("Promptly provide the complaining party with a copy of the counter - notification;") }}</li>
      <li>
        {{
          t(
            "Inform the complaining party that we will replace the removed material or cease disabling access to it within seven(7) business days;",
          )
        }}
      </li>
      <li>
        {{
          t(
            "Replace the removed material or cease disabling access to the material within seven(7) to fourteen(14) business days following receipt of the counter - notification, provided our designated agent has not received notice from the complaining party that an action has been filed seeking a court order to restrain Users from engaging in infringing activity relating to the material on our network or system.",
          )
        }}
      </li>
      <li>
        {{
          t(
            "Please note that federal law provides significant penalties for submitting a false counter - notification.Please also note that pursuant to the Digital Millennium Copyright Act, we cannot and do not judge the merits of your claim(or counter - claim). Accordingly, we will not remove, or disable access to, any allegedly infringing material, nor restore any material that has been so removed, except according to the procedure set forth herein.",
          )
        }}
      </li>
    </ul>

    <h2>{{ t("Repeat Infringers") }}</h2>

    <p>
      {{
        t(
          "We may, at our discretion, terminate the account of any User in which we receive more than one notice of claimed infringement in any twelve - month period.",
        )
      }}
    </p>
  </div>
</template>

<script setup lang="ts">
import Imprint from "@/components/imprint/index.vue";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "dmca-text",
});
const { t } = useI18n();
</script>

<style lang="scss">
@import "./index";
</style>
